import React, { useEffect, useState } from 'react';
import { useAppSelector } from 'src/hooks';
import CollapsibleTable from 'src/components/collapsible-table/collapsible-table';
import { AiFillDownCircle } from 'react-icons/ai';
import { Grid } from '@mui/material';
import { Accordion } from 'src/components/expandable-accordion/accordion-style';
import { getTableColumnData } from 'src/components/collapsible-table/table-column-prep';
import { makeDataForTable } from 'src/components/collapsible-table/table-data-prep';
import { MultiSelect } from 'react-multi-select-component';
import { AccordionSummary } from 'src/components/expandable-accordion/accordion-summary';
import { AccordionDetails } from 'src/components/expandable-accordion/accordion-details';
import { titleData } from '../../utils/constants';
import { TableComponent } from '../../../pricing-simulator/types/generic-table.model';
import '../../../pricing-simulator/components/list-price-simulation-table/list-price-simulation.scss';
import '../../../../../../components/filters/components/filters.scss';
import TableSkeletonContainer from '../../../pricing-simulator/components/simulation-table-container/table-skeleton';

export default function ImpactAtPPGLevelTable() {
  const [columnVisibility, setColumnVisibility] = React.useState({
    columnVisibility: {}
  });
  const { ppgLevelImpactData, fetchingPPGLevelImpactData } = useAppSelector(
    (state) => state.summary
  );

  const { inputCols } = useAppSelector(
    (state) => state.summary.ppgLevelImpactData
  );

  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [selectedMenu, setSelectedMenu] = useState([]);
  const [options, setOptions] = useState([]);
  const [expandedPanel, setExpandedPanel] = useState<boolean>(true);
  const [isStickyCol, setIsStickyCol] = useState([]);

  useEffect(() => {
    if (Object.keys(inputCols).length > 0) {
      setColumns(
        getTableColumnData(
          inputCols,
          TableComponent.PPGLEVELIMPACT,
          ppgLevelImpactData.columns,
          ppgLevelImpactData?.footer?.row
        )
      );
      setRows(
        makeDataForTable(ppgLevelImpactData.rows).sort((p1, p2) =>
          p1.cell > p2.cell ? 1 : p1.cell < p2.cell ? -1 : 0
        )
      );
      const dropdownColNames = ppgLevelImpactData.inputCols
        .filter((opt) => !opt.parent.is_sticky_column)
        .map((opt) => ({
          label: opt.parent.alias,
          value: opt.parent.parent_field
        }));

      const isSticky = ppgLevelImpactData.inputCols
        .filter((opt) => opt.parent.is_sticky_column)
        .map((opt) => opt.parent.parent_field);
      setIsStickyCol(isSticky);

      setOptions(dropdownColNames);
      setSelectedMenu(dropdownColNames);
      const colsVisible = {};
      ppgLevelImpactData.inputCols.forEach((cols) => {
        colsVisible[cols.parent.parent_field] = true;
      });
      setColumnVisibility({ columnVisibility: colsVisible });
    }
  }, [inputCols]);

  const handleChangeMultiSelect = (selectedColsArr: any) => {
    const colsVisible = columnVisibility?.columnVisibility;
    const selectedValue = selectedColsArr.map((element) => element.value);
    // eslint-disable-next-line no-restricted-syntax
    for (const col in colsVisible) {
      if (!selectedValue.includes(col) && !isStickyCol.includes(col)) {
        colsVisible[col] = false;
      } else {
        colsVisible[col] = true;
      }
    }
    setSelectedMenu(selectedColsArr);
    setColumnVisibility({ columnVisibility: colsVisible });
    const newCols = inputCols.filter((col, index) => {
      if (col.parent.is_sticky_column) {
        return true;
      }
      return selectedValue.includes(col.parent.parent_field);
    });
    setColumns(
      getTableColumnData(
        newCols,
        TableComponent.PPGLEVELIMPACT,
        ppgLevelImpactData.columns,
        ppgLevelImpactData.footer.row
      )
    );
  };

  return (
    <div style={{ height: '380px', overflowY: 'auto' }}>
      {fetchingPPGLevelImpactData ? (
        <TableSkeletonContainer rowLength={5} headerLength={6} />
      ) : (
        <Accordion
          expanded={expandedPanel}
          onChange={() => {
            setExpandedPanel(!expandedPanel);
          }}
        >
          <Grid container my={1} style={{ paddingTop: '0px', width: '100%' }}>
            <Grid
              item
              xs={2}
              className='container-title'
              style={{ paddingTop: '0px !important' }}
            >
              <AccordionSummary
                expandIcon={<AiFillDownCircle color='#0000a0' />}
                aria-controls='panel1d-content'
                id='panel1d-header'
                style={{ width: '100%' }}
              >
                {' '}
                {titleData.ppgLevelImpact}
              </AccordionSummary>
            </Grid>

            <Grid
              item
              xs={10}
              style={{ paddingTop: '0px', textAlign: 'right' }}
            >
              <span className='view-by-label'>Columns</span>
              <div
                className='ppg-multi-select filter-div'
                style={{
                  width: '20%',
                  margin: '10px',
                  float: 'right',
                  textAlign: 'left'
                }}
              >
                <MultiSelect
                  options={options}
                  value={selectedMenu}
                  onChange={(val) => handleChangeMultiSelect(val)}
                  labelledBy='Select'
                  className='multi-select-div'
                  overrideStrings={{
                    allItemsAreSelected: 'All'
                  }}
                />
              </div>
            </Grid>
          </Grid>
          <AccordionDetails style={{ padding: '0px' }}>
            <div style={{ margin: '0px 10px' }}>
              <CollapsibleTable
                data={rows}
                setHeightExplicitly={false}
                extClassName='summary-impact-table'
                columns={columns}
                tableState={columnVisibility}
              />
            </div>
          </AccordionDetails>
        </Accordion>
      )}
    </div>
  );
}
